import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon } from 'lucide-react';
export function ValueStack() {
  const bonuses = [{
    title: 'Lista de Compras Desinflamante',
    desc: 'Sabé exactamente qué llevar del supermercado para desinflamar tu hígado sin gastar de más.',
    value: '$4.500'
  }, {
    title: 'Tabla de Reemplazos',
    desc: 'Reemplazos rápidos y saludables para tus ingredientes y comidas de todos los días.',
    value: '$3.900'
  }, {
    title: 'Menú 7 Días para Hígado Graso',
    desc: 'Un plan completo de una semana, listo para seguir desde el primer día.',
    value: '$5.200'
  }, {
    title: '100 Recetas Sin Azúcar Ni Harina',
    desc: 'Para cuidar tu hígado sin dejar de comer rico, con ingredientes simples y para toda la familia.',
    value: '$5.500'
  }, {
    title: 'Recetas Keto',
    desc: 'Recetas bajas en carbohidratos, fáciles y saciantes para comer rico todos los días.',
    value: '$4.900'
  }, {
    title: 'Delicias para Diabéticos',
    desc: 'Postres y delicias aptas para diabéticos, sin culpa y sin disparar tu glucemia.',
    value: '$4.000'
  }];
  return <section className="py-20 bg-stone-50" data-id="element-233">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
        <div className="text-center mb-12" data-id="element-235">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-236">
            Además de la guía principal, <br className="hidden sm:block" data-id="element-237" />
            <span className="text-brand-600" data-id="element-238">te llevás 6 BONOS GRATIS hoy</span>
          </h2>
          <p className="text-lg text-stone-600" data-id="element-239">
            Todo lo que necesitás para asegurar tu éxito, incluido sin costo
            adicional.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12 rounded-3xl overflow-hidden" data-id="element-240">
          <img src="https://cdn.magicpatterns.com/uploads/37SuAhg34D15ZKVbbp2NEd/6_regalos_exclusivos_por_hoy_800.webp" alt="6 regalos exclusivos: Lista de Compras Desinflamante, Tabla de Reemplazos, Menú 7 Días para Hígado Graso, 100 Recetas Sin Azúcar Ni Harina, Recetas Keto y Delicias para Diabéticos" className="w-full h-auto" data-id="element-241" />
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-242">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-stone-200 rounded-2xl p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-243">
              <div className="w-12 h-12 bg-accent-100 text-accent-600 rounded-xl flex items-center justify-center shrink-0" data-id="element-244">
                <GiftIcon className="w-6 h-6" data-id="element-245" />
              </div>
              <div className="flex-grow" data-id="element-246">
                <h3 className="text-lg font-bold text-stone-900 mb-1" data-id="element-247">
                  Bono #{i + 1}: {bonus.title}
                </h3>
                <p className="text-stone-600 text-sm sm:text-base" data-id="element-248">
                  {bonus.desc}
                </p>
              </div>
              <div className="mt-2 sm:mt-0 bg-stone-100 px-3 py-1 rounded-full text-sm font-medium text-stone-500 line-through shrink-0" data-id="element-249">
                Valor: {bonus.value}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-stone-900 text-white rounded-3xl p-8 text-center shadow-xl relative overflow-hidden" data-id="element-250">
          <div className="absolute top-0 right-0 w-32 h-32 bg-accent-500 rounded-bl-full opacity-20" data-id="element-251"></div>

          <h3 className="text-2xl font-bold mb-6 relative z-10" data-id="element-252">
            Resumen de lo que te llevás hoy:
          </h3>

          <ul className="text-left max-w-md mx-auto space-y-3 mb-8 relative z-10" data-id="element-253">
            <li className="flex items-center gap-3" data-id="element-254">
              <CheckIcon className="w-5 h-5 text-brand-400" data-id="element-255" /> Guía Chau Hígado
              Graso
            </li>
            <li className="flex items-center gap-3" data-id="element-256">
              <CheckIcon className="w-5 h-5 text-brand-400" data-id="element-257" /> Menú de 7 días y
              Recetas
            </li>
            <li className="flex items-center gap-3" data-id="element-258">
              <CheckIcon className="w-5 h-5 text-accent-400" data-id="element-259" /> + Los 6 Bonos
              Exclusivos
            </li>
          </ul>

          <div className="border-t border-stone-700 pt-6 relative z-10" data-id="element-260">
            <p className="text-stone-400 mb-2" data-id="element-261">
              Valor total real:{' '}
              <span className="line-through" data-id="element-262">$34.000 ARS</span>
            </p>
            <p className="text-xl mb-1" data-id="element-263">Tu inversión hoy:</p>
            <p className="text-5xl font-extrabold text-accent-400 mb-2" data-id="element-264">
              $14.999 <span className="text-2xl font-medium" data-id="element-265">ARS</span>
            </p>
            <p className="text-sm text-stone-400" data-id="element-266">
              Pago único. Acceso inmediato.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}